<ng-content></ng-content>

@if (!disableSpacer) {
  <div class="spacer"></div>
}
